import banner from '@/api/banners'
import * as types from '../mutation-types'
import Vue from 'vue'

const state = {
  banners: {},
  loadingBanners: false
}

const getters = {
  getBannersForFairExplorePage: (state) => (fairExplorePath) => {
    return state.banners[fairExplorePath]
  }
}

const actions = {
  getCategorySetsForFairExplorePage ({ commit, state }, fairExplorePath) {
    return new Promise((resolve, reject) => {
      if (state.loadingBanners) {
        return
      }

      if (state.banners[fairExplorePath]) {
        resolve(state.banners[fairExplorePath])
        return
      }

      commit(types.LOADING_EXPLORE_PAGE_BANNER, true)
      banner.getCategorySetsForFairExplorePage(fairExplorePath).then((response) => {
        commit(types.ADD_EXPLORE_PAGE_BANNER, { fairExplorePath: fairExplorePath, banners: response.data.result.banners })
        commit(types.LOADING_EXPLORE_PAGE_BANNER, false)
        resolve(response.data.result.banners)
      })
    })
  }
}

const mutations = {
  [types.ADD_EXPLORE_PAGE_BANNER] (state, { fairExplorePath, banners }) {
    Vue.set(state.banners, fairExplorePath, banners)
  },
  [types.LOADING_EXPLORE_PAGE_BANNER] (state, loading) {
    state.loadingBanners = loading
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
